import { EntityType, Variant } from 'common/enums';
import { PreviewEntityDTO } from 'common/models/data/entity.model';

export const getHierarchicalData = (): PreviewEntityDTO[] => {
    return [
        {
            id: '1',
            isSelected: false,
            name: 'Big Issues',
            order: '1',
            hasChild: true,
            hasError: false,
            childHasError: true,
            entityType: EntityType.Category,
            hasChildIndicatorsOnly: false,
            errors: [],
            subCategories: [
                {
                    id: '2',
                    parentId: '1',
                    isSelected: false,
                    name: '7 drivers of growth',
                    order: '2',
                    hasChild: true,
                    hasError: false,
                    childHasError: true,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: false,
                    errors: [],
                    subCategories: [
                        {
                            id: '3',
                            parentId: '2',
                            isSelected: false,
                            name: 'Customer',
                            order: '3',
                            hasChild: true,
                            hasError: false,
                            childHasError: true,
                            entityType: EntityType.SubCategory,
                            hasChildIndicatorsOnly: true,
                            errors: [],
                            subCategories: [
                                {
                                    id: '4',
                                    parentId: '3',
                                    isSelected: false,
                                    name: 'Adults using electronic payments',
                                    order: '1',
                                    entityType: EntityType.Indicator,
                                    hasChild: false,
                                    childHasError: false,
                                    hasError: true,
                                    errors: [
                                        {
                                            message: 'Name exceeds 200 characters',
                                            field: 'name'
                                        }
                                    ]
                                },
                                {
                                    id: '5',
                                    parentId: '3',
                                    isSelected: false,
                                    name: 'Buyer sophistication rating',
                                    order: '2',
                                    entityType: EntityType.Indicator,
                                    childHasError: false,
                                    hasChild: false,
                                    hasError: false,
                                    subCategories: [],
                                    errors: []
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: '8',
            isSelected: false,
            name: 'Country essentials',
            order: '1',
            hasChild: true,
            hasError: true,
            description: 'description!!',
            childHasError: false,
            errors: [
                {
                    message: 'Name exceeds 200 characters',
                    field: 'name'
                },
                {
                    message: 'Description has special characters',
                    field: 'description'
                }
            ],
            entityType: EntityType.Category,
            hasChildIndicatorsOnly: false,
            subCategories: [
                {
                    id: '9',
                    parentId: '8',
                    isSelected: false,
                    name: 'Population',
                    order: '2',
                    hasChild: true,
                    hasError: false,
                    childHasError: false,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: true,
                    errors: [],
                    subCategories: [
                        {
                            id: '10',
                            parentId: '9',
                            isSelected: false,
                            name: 'Population growth',
                            order: '1',
                            errors: [],
                            entityType: EntityType.Indicator
                        },
                        {
                            id: '11',
                            parentId: '9',
                            isSelected: false,
                            name: 'Population median age',
                            order: '2',
                            errors: [],
                            entityType: EntityType.Indicator
                        }
                    ]
                },
                {
                    id: '12',
                    isSelected: false,
                    name: 'Education',
                    order: '2',
                    hasChild: true,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: true,
                    errors: [],
                    subCategories: [
                        {
                            id: '13',
                            isSelected: false,
                            name: 'Literacy rate by country',
                            order: '1',
                            errors: [],
                            entityType: EntityType.Indicator
                        },
                        {
                            id: '14',
                            isSelected: false,
                            name: 'Equal access to quality education',
                            order: '2',
                            errors: [],
                            childHasError: false,
                            entityType: EntityType.Indicator
                        }
                    ]
                }
            ]
        },
        {
            id: '15',
            isSelected: false,
            name: 'Economics, tax and legal',
            order: '1',
            hasChild: true,
            hasError: false,
            childHasError: false,
            errors: [],
            entityType: EntityType.Category,
            hasChildIndicatorsOnly: false,
            subCategories: [
                {
                    id: '16',
                    parentId: '15',
                    isSelected: false,
                    name: 'GDP and economic factors',
                    order: '2',
                    hasChild: true,
                    hasError: false,
                    childHasError: false,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: false,
                    errors: [],
                    subCategories: [
                        {
                            id: '17',
                            parentId: '16',
                            isSelected: false,
                            name: 'Comparative Economics',
                            order: '3',
                            hasChild: true,
                            hasError: false,
                            childHasError: false,
                            errors: [],
                            entityType: EntityType.SubCategory,
                            hasChildIndicatorsOnly: true,
                            subCategories: [
                                {
                                    id: '18',
                                    parentId: '17',
                                    isSelected: false,
                                    name: 'Cost of living index',
                                    order: '4',
                                    errors: [],
                                    entityType: EntityType.Indicator
                                },
                                {
                                    id: '19',
                                    parentId: '17',
                                    isSelected: false,
                                    name: 'Property Price to income ratio',
                                    order: '4',
                                    errors: [],
                                    entityType: EntityType.Indicator
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: '22',
            isSelected: false,
            name: 'Sectors',
            order: '1',
            hasChild: true,
            hasError: false,
            childHasError: false,
            errors: [],
            entityType: EntityType.Category,
            hasChildIndicatorsOnly: false,
            subCategories: [
                {
                    id: '23',
                    parentId: '22',
                    isSelected: false,
                    name: 'Automotive and transportation',
                    order: '2',
                    hasChild: true,
                    hasError: false,
                    childHasError: false,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: true,
                    errors: [],
                    subCategories: [
                        {
                            id: '24',
                            parentId: '23',
                            isSelected: false,
                            name: 'Electric vehicle sales',
                            order: '3',
                            errors: [],
                            entityType: EntityType.Indicator
                        },
                        {
                            id: '251',
                            parentId: '23',
                            isSelected: false,
                            name: 'New commercial vehicle sales number p.a',
                            order: '3',
                            errors: [],
                            entityType: EntityType.Indicator
                        }
                    ]
                },
                {
                    id: '26',
                    parentId: '22',
                    isSelected: false,
                    name: 'Consumer Products & Retail',
                    order: '2',
                    hasChild: true,
                    hasError: false,
                    childHasError: false,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: true,
                    errors: [],
                    subCategories: [
                        {
                            id: '27',
                            parentId: '26',
                            isSelected: false,
                            name: 'Consumer Confidence',
                            order: '3',
                            errors: [],
                            entityType: EntityType.Indicator
                        },
                        {
                            id: '28',
                            parentId: '26',
                            isSelected: false,
                            name: 'Cost of living index',
                            order: '3',
                            errors: [],
                            entityType: EntityType.Indicator
                        }
                    ]
                }
            ]
        }
    ];
};

export const getWhatsNewList = () => {
    return [
        {
            sno: 1,
            name: 'Economic Freedom Index - Overall Score',
            type: 'article',
            link: '',
            order: 1
        },
        {
            sno: 2,
            name: 'Economic Freedom Index - Overall Score',
            type: 'image',
            link: '',
            order: 2
        },
        {
            sno: 3,
            name: 'Economic Freedom Index - Overall Score',
            type: 'video',
            link: '',
            order: 3
        },
        {
            sno: 4,
            name: 'Economic Freedom Index - Overall Score',
            type: 'application',
            link: '',
            order: 4
        },
        {
            sno: 5,
            name: 'Economic Freedom Index - Overall Score',
            type: 'indicator',
            link: '',
            order: 5
        }
    ];
};
export const getTrendingData = (): any[] => {
    return [
        {
            id: '1',
            sno: '1',
            indicator: 'Adults using electronic payment',
            indicator_level: 'Big Issues > 7 drivers of growth > Customer'
        },
        {
            id: '2',
            sno: '2',
            indicator: 'Buyer sophistication rating',
            indicator_level: 'Big Issues > 7 drivers of growth > Customer'
        },
        {
            id: '3',
            sno: '3',
            indicator: 'Population growth',
            indicator_level: 'Country essentials > Populations'
        },
        {
            id: '4',
            sno: '4',
            indicator: 'Population median age',
            indicator_level: 'Country essentials > Populations '
        },
        {
            id: '5',
            sno: '5',
            indicator: 'Literacy rate by country',
            indicator_level: 'Country essentials > Education '
        },
        {
            id: '6',
            sno: '6',
            indicator: 'Equal access to quality education',
            indicator_level: 'Country essentials > Education '
        }
    ];
};

export const getArchiveList = (): any[] => {
    return [
        {
            id: '1',
            isSelected: false,
            name: 'Big Issues',
            order: '1',
            hasChild: true,
            hasError: false,
            childHasError: true,
            entityType: EntityType.Category,
            hasChildIndicatorsOnly: false,
            errors: [],
            variant: Variant.MasterData,
            subCategories: [
                {
                    id: '2',
                    parentId: '1',
                    isSelected: false,
                    name: '7 drivers of growth',
                    order: '2',
                    hasChild: true,
                    hasError: false,
                    childHasError: true,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: false,
                    errors: [],
                    variant: Variant.MasterData,
                    subCategories: [
                        {
                            id: '3',
                            parentId: '2',
                            isSelected: false,
                            name: 'Customer',
                            order: '3',
                            hasChild: true,
                            hasError: false,
                            childHasError: true,
                            entityType: EntityType.SubCategory,
                            hasChildIndicatorsOnly: true,
                            errors: [],
                            variant: Variant.MasterData,
                            subCategories: [
                                {
                                    id: '4',
                                    parentId: '3',
                                    isSelected: false,
                                    name: 'Adults using electronic payments',
                                    order: '1',
                                    entityType: EntityType.Indicator,
                                    hasChild: false,
                                    childHasError: false,
                                    hasError: true,
                                    errors: [
                                        {
                                            message: 'Name exceeds 200 characters',
                                            field: 'name'
                                        }
                                    ],
                                    variant: Variant.MasterData
                                },
                                {
                                    id: '5',
                                    parentId: '3',
                                    isSelected: false,
                                    name: 'Buyer sophistication rating',
                                    order: '2',
                                    entityType: EntityType.Indicator,
                                    childHasError: false,
                                    hasChild: false,
                                    hasError: false,
                                    subCategories: [],
                                    errors: [],
                                    variant: Variant.MasterData
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: '8',
            isSelected: false,
            name: 'Country essentials',
            order: '1',
            hasChild: true,
            hasError: true,
            description: 'description!!',
            childHasError: false,
            variant: Variant.MasterData,
            errors: [
                {
                    message: 'Name exceeds 200 characters',
                    field: 'name'
                },
                {
                    message: 'Description has special characters',
                    field: 'description'
                }
            ],
            entityType: EntityType.Category,
            hasChildIndicatorsOnly: false,
            subCategories: [
                {
                    id: '9',
                    parentId: '8',
                    isSelected: false,
                    name: 'Population',
                    order: '2',
                    hasChild: true,
                    hasError: false,
                    childHasError: false,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: true,
                    errors: [],
                    variant: Variant.MasterData,
                    subCategories: [
                        {
                            id: '10',
                            parentId: '9',
                            isSelected: false,
                            name: 'Population growth',
                            order: '1',
                            errors: [],
                            variant: Variant.MasterData,
                            entityType: EntityType.Indicator
                        },
                        {
                            id: '11',
                            parentId: '9',
                            isSelected: false,
                            name: 'Population median age',
                            order: '2',
                            errors: [],
                            variant: Variant.MasterData,
                            entityType: EntityType.Indicator
                        }
                    ]
                },
                {
                    id: '12',
                    isSelected: false,
                    name: 'Education',
                    order: '2',
                    hasChild: true,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: true,
                    errors: [],
                    variant: Variant.MasterData,
                    subCategories: [
                        {
                            id: '13',
                            isSelected: false,
                            name: 'Literacy rate by country',
                            order: '1',
                            errors: [],
                            variant: Variant.MasterData,
                            entityType: EntityType.Indicator
                        },
                        {
                            id: '14',
                            isSelected: false,
                            name: 'Equal access to quality education',
                            order: '2',
                            errors: [],
                            variant: Variant.MasterData,
                            childHasError: false,
                            entityType: EntityType.Indicator
                        }
                    ]
                }
            ]
        },
        {
            id: '15',
            isSelected: false,
            name: 'Economics, tax and legal',
            order: '1',
            hasChild: true,
            hasError: false,
            childHasError: false,
            errors: [],
            entityType: EntityType.Category,
            hasChildIndicatorsOnly: false,
            variant: Variant.MasterData,

            subCategories: [
                {
                    id: '16',
                    parentId: '15',
                    isSelected: false,
                    name: 'GDP and economic factors',
                    order: '2',
                    hasChild: true,
                    hasError: false,
                    childHasError: false,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: false,
                    errors: [],
                    variant: Variant.MasterData,
                    subCategories: [
                        {
                            id: '17',
                            parentId: '16',
                            isSelected: false,
                            name: 'Comparative Economics',
                            order: '3',
                            hasChild: true,
                            hasError: false,
                            childHasError: false,
                            errors: [],
                            variant: Variant.MasterData,
                            entityType: EntityType.SubCategory,
                            hasChildIndicatorsOnly: true,
                            subCategories: [
                                {
                                    id: '18',
                                    parentId: '17',
                                    isSelected: false,
                                    name: 'Cost of living index',
                                    order: '4',
                                    errors: [],
                                    variant: Variant.MasterData,
                                    entityType: EntityType.Indicator
                                },
                                {
                                    id: '19',
                                    parentId: '17',
                                    isSelected: false,
                                    name: 'Property Price to income ratio',
                                    order: '4',
                                    errors: [],
                                    variant: Variant.MasterData,
                                    entityType: EntityType.Indicator
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: '22',
            isSelected: false,
            name: 'Sectors',
            order: '1',
            hasChild: true,
            hasError: false,
            childHasError: false,
            errors: [],
            entityType: EntityType.Category,
            hasChildIndicatorsOnly: false,
            variant: Variant.MasterData,
            subCategories: [
                {
                    id: '23',
                    parentId: '22',
                    isSelected: false,
                    name: 'Automotive and transportation',
                    order: '2',
                    hasChild: true,
                    hasError: false,
                    childHasError: false,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: true,
                    errors: [],
                    variant: Variant.MasterData,
                    subCategories: [
                        {
                            id: '24',
                            parentId: '23',
                            isSelected: false,
                            name: 'Electric vehicle sales',
                            order: '3',
                            errors: [],
                            variant: Variant.MasterData,
                            entityType: EntityType.Indicator
                        },
                        {
                            id: '251',
                            parentId: '23',
                            isSelected: false,
                            name: 'New commercial vehicle sales number p.a',
                            order: '3',
                            errors: [],
                            variant: Variant.MasterData,
                            entityType: EntityType.Indicator
                        }
                    ]
                },
                {
                    id: '26',
                    parentId: '22',
                    isSelected: false,
                    name: 'Consumer Products & Retail',
                    order: '2',
                    hasChild: true,
                    hasError: false,
                    childHasError: false,
                    entityType: EntityType.SubCategory,
                    hasChildIndicatorsOnly: true,
                    errors: [],
                    variant: Variant.MasterData,
                    subCategories: [
                        {
                            id: '27',
                            parentId: '26',
                            isSelected: false,
                            name: 'Consumer Confidence',
                            order: '3',
                            errors: [],
                            variant: Variant.MasterData,
                            entityType: EntityType.Indicator
                        },
                        {
                            id: '28',
                            parentId: '26',
                            isSelected: false,
                            name: 'Cost of living index',
                            order: '3',
                            errors: [],
                            variant: Variant.MasterData,
                            entityType: EntityType.Indicator
                        }
                    ]
                }
            ]
        }
    ];
};
